import { WidgetHeaderTextType } from '../../components/common/types';

interface GetWidgetHeaderTextProps {
    widgetTitle: string;
    cityName?: string;
    stateAbbreviation?: string;
    displayCompositeName?: string;
}

export const getWidgetHeaderText = ({ widgetTitle, cityName, stateAbbreviation, displayCompositeName }: GetWidgetHeaderTextProps ): WidgetHeaderTextType => {

    let subWidgetTitle = null;

    if (cityName && stateAbbreviation) {
        subWidgetTitle = `${cityName}, ${stateAbbreviation}`;
    } else if (displayCompositeName) {
        subWidgetTitle = displayCompositeName;
    }

    return { widgetTitle, subWidgetTitle };
};